(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module is expecting
    // the UriSegmentConfig to exists on the window object.
    define('uriSegmentConfig',[], () => factory(global));
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this UriSegmentConfig.
    module.exports = factory(global);
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    factory(global);
  }
}(
  typeof window !== 'undefined' ? window : {},
  (global) => {
    'use strict';

    global.NewHomeSource = global.NewHomeSource || {};

    const previousUriSegmentConfig = global.NewHomeSource.UriSegmentConfig;
    const uriSegmentParameters = {
      HomeStatus: 1,
      SingleFamily: 1,
    };

    /**
     * @constructs NewHomeSource.UriSegments
     */
    function UriSegmentConfig() {
    }

    /*
    * Gets the hierarchy of the filter applied.
    * @param {Object} List of applied filters.
    * @returns a list with the hierarchy of the parameters
    */
    UriSegmentConfig.getUriSegmentHierarchy = function getHierarchy(parameters) {
      // The hierarchy always starts at the SrpType.
      const hierarchy = ['SrpType'];

      Object.keys(parameters).forEach((key) => {
        const isAnUriSegment = !!uriSegmentParameters[key];

        if (isAnUriSegment && !!parameters[key]) {
          hierarchy.push(key);
        }
      });

      return hierarchy;
    };

    /**
     * @public
     *
     * noConflict: Returns control of NewHomeSource.UriSegmentConfig to the previous script.
     */
    UriSegmentConfig.noConflict = function noConflict() {
      global.NewHomeSource.UriSegmentConfig = previousUriSegmentConfig;
      return UriSegmentConfig;
    };

    global.NewHomeSource.UriSegmentConfig = UriSegmentConfig;

    return UriSegmentConfig;
  }
));

